import fetch from 'cross-fetch';
import type { FetcherOptions } from '../types';

export default async function cFetch<T>(
  url: string,
  options?: FetcherOptions
): Promise<T> {
  const res = await fetch(url, options);

  return res.json();
}
